export const BUY_BUTTON_TARIFF_BENEFITS_MODAL_ID = 'buy_button_tariff_benefits_modal';
export const MODAL_TARIFF_BENEFITS_PAY_SOURCE = 'modal_tariff_benefits';
